import { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {

  const [dropdown, setDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">

      {/* LEFT SIDE LOGO + NAME */}
      <div className="logo-area">
        <img src="/images/clglogoo.png" alt="logo" className="logo-img"/>
        <div className="logo">MASTERS DEGREE & PG COLLEGE</div>
      </div>

      {/* MOBILE HAMBURGER */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      {/* NAVIGATION MENU */}
      <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>

        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        </li>

        {/* DROPDOWN */}
        <li 
          className="dropdown"
          onClick={() => setDropdown(!dropdown)}
        >
          <span className="menu-btn">Academics ▾</span>

          <ul className={`dropdown-menu ${dropdown ? "show" : ""}`}>
            <li>
              <Link to="/academics" onClick={() => setMenuOpen(false)}>
                Degree Programs
              </Link>
            </li>
            <li>
              <Link to="/academics" onClick={() => setMenuOpen(false)}>
                PG Programs
              </Link>
            </li>
          </ul>
        </li>

        <li>
          <Link to="/links" onClick={() => setMenuOpen(false)}>Useful Links</Link>
        </li>

        <li>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>
        </li>

        <li>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
        </li>

      </ul>
    </nav>
  );
}

export default Navbar;
